import { jsx as v } from "react/jsx-runtime";
import { c as z } from "react/compiler-runtime";
import { forwardRef as G } from "react";
import g from "@mui/material/Grid";
const j = G((c, x) => {
  const e = z(23);
  let d, l, t, f, m, o, s, r;
  e[0] !== c ? ({
    children: d,
    xs: r,
    sm: o,
    md: t,
    lg: l,
    xl: s,
    size: m,
    ...f
  } = c, e[0] = c, e[1] = d, e[2] = l, e[3] = t, e[4] = f, e[5] = m, e[6] = o, e[7] = s, e[8] = r) : (d = e[1], l = e[2], t = e[3], f = e[4], m = e[5], o = e[6], s = e[7], r = e[8]);
  let i;
  e[9] !== l || e[10] !== t || e[11] !== o || e[12] !== s || e[13] !== r ? (i = {}, r !== void 0 && (i.xs = r), o !== void 0 && (i.sm = o), t !== void 0 && (i.md = t), l !== void 0 && (i.lg = l), s !== void 0 && (i.xl = s), e[9] = l, e[10] = t, e[11] = o, e[12] = s, e[13] = r, e[14] = i) : i = e[14];
  let n;
  e[15] !== m || e[16] !== i ? (n = Object.keys(i).length > 0 ? i : m, e[15] = m, e[16] = i, e[17] = n) : n = e[17];
  const a = n;
  let p;
  return e[18] !== d || e[19] !== a || e[20] !== f || e[21] !== x ? (p = /* @__PURE__ */ v(g, { ref: x, size: a, ...f, children: d }), e[18] = d, e[19] = a, e[20] = f, e[21] = x, e[22] = p) : p = e[22], p;
});
j.displayName = "Grid";
export {
  j as Grid,
  j as GridComponent
};
